import { createRoute } from 'framework/routing';

const COST_ACCOUNTING_PATH = '/cost-accounting';

export const getCostAccountingListUrl = () => COST_ACCOUNTING_PATH;

export const getCostAccountingRouterPath = () => `${COST_ACCOUNTING_PATH}/*`;

export const useCostAccountingRoute = () => createRoute({ listRoute: COST_ACCOUNTING_PATH });
